import React, { memo } from "react"
import styled from "styled-components"
import Link from "next/link"
import dayjs from "dayjs"

interface Props {
  title?: string
  // headers: { key: string; title?: string; width?: string; render?: (data: any, columnData: any) => ReactChild }[]
  dataSources: { [KEY in string]: string | number }[]
  limit?: number
  onMore?: () => void
}

function ActivityView(props: Props) {
  const { title, dataSources, limit, onMore } = props

  return (
    <Content>
      <LinkArea>
        <div className={"title"}>{title}</div>
      </LinkArea>
      {dataSources && (
        <Table>
          {dataSources.map((dataSource, dataSourceIndex) => (
            <React.Fragment key={dataSourceIndex}>
              <div className={"table-row"}>
                <div className={"message"}>
                  <Link
                    href={{
                      pathname: `/contracts${dataSource.version === 2 ? "-next" : ""}/${
                        dataSource.id
                      }`,
                    }}
                  >
                    {dataSource.name}
                  </Link>
                  {dataSource.message}
                </div>
                <div className={"bottom"}>
                  <span>{dayjs(dataSource.date).format("YYYY/MM/DD HH:mm")}</span>
                  <span>{dataSource.from}</span>
                </div>
              </div>
            </React.Fragment>
          ))}
        </Table>
      )}
    </Content>
  )
}
const Content = styled.div`
  background-color: #ffffff;
  width: 48%;
  border: 1px solid #d3d3d3;
`

const LinkArea = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid #d3d3d3;

  .title {
    font-size: 16px;
    font-weight: bold;
  }
`

const Table = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 430px;
  overflow-y: scroll;

  > div {
    display: flex;
    text-align: center;
  }

  .table-row {
    display: flex;
    align-items: baseline;
    padding: 20px;
    border-bottom: 1px dashed #d3d3d3;
    flex-direction: column;

    .message {
      margin-bottom: 10px;

      > a {
        color: #4f4ce6;
      }
    }
    .bottom {
      span {
        margin-right: 10px;
      }
    }
  }
`

export default memo(ActivityView)
